// removed by extract-text-webpack-plugin
module.exports = {"SectionWithHeader":"vhMHFfGAGmmtM0ByXLsd-","Header":"_2nOKGNFdro_u0ui537Zxdu","HeaderRight":"eqAeMdTmqRoJho4OJKWNr"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/SectionWithHeader/index.css
// module id = 845
// module chunks = 0